module.exports = __webpack_public_path__ + "img/antmedia.89460543.png";